export default {"src":"/_next/static/media/dhss-logo-without-title.5be427a6.svg","height":555,"width":541,"blurWidth":0,"blurHeight":0};